export default "https://cdn-static.gokick.com/assets/3258f73df43fa954b49bc6bd6de466cccdb5fe2c/images/picture-of-you.b930d7b92f771d9006a5673f9ae1716c.svg";